import React from 'react'
import { useHistory } from 'react-router-dom'

import { ThemeProvider } from '@mui/material'
import { getColorMode, getTheme } from 'themes'

import { useDashboardsInSameGroup } from 'redux/hooks/Dashboards'

import { Context } from 'types/GlobalUserEvents'
import { addRef } from 'utils/queryHandler'

import Box from 'components_new/atoms/Box'
import MenuItem from 'components_new/atoms/Menu/MenuItem'
import TextField from 'components_new/atoms/TextField'
import { useParams } from 'utils/hooks'
import { useBackgroundColor } from 'redux/hooks/Customization'
import { useDashboardFoldersFetched } from 'redux/hooks/DashboardFolders'

const MobileTabSelector = () => {
  const history = useHistory()

  const params = useParams<{ id: string }>()
  const backgroundColor = useBackgroundColor()
  const dashboardsInSameGroup = useDashboardsInSameGroup(params.id)
  const foldersFetched = useDashboardFoldersFetched()

  const isLoading = !foldersFetched || dashboardsInSameGroup.length === 0

  if (isLoading) return <></>

  return (
    <ThemeProvider
      theme={getTheme(
        backgroundColor ? getColorMode(backgroundColor) : 'light',
        null,
        {
          responsive: true
        }
      )}
    >
      <Box
        sx={{
          bgcolor: backgroundColor ?? 'background.paper',
          px: 1.75,
          pb: 1.75,
          pt: 3.5
        }}
      >
        <TextField
          label="Flik"
          noGutter={true}
          onChange={(event) => {
            history.push(
              addRef(
                `/dashboards/${event.target.value}`,
                Context.NAVIGATE_TO_NEW_TAB
              )
            )
          }}
          placeholder="Välj..."
          select={true}
          value={params.id}
        >
          {dashboardsInSameGroup.map((dashboard) => (
            <MenuItem key={dashboard.id} value={dashboard.id}>
              {dashboard.title}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </ThemeProvider>
  )
}

export default MobileTabSelector
